import React, {lazy, Suspense} from 'react';
import Parcel from 'single-spa-react/parcel';
import { CprIcon } from 'canopy-styleguide!sofe';

import styles from './nav-items.styles.css';

const TimeIndicator = lazy(() =>
  SystemJS.import('billing-ui!sofe').then(billingUI => billingUI.getTimeIndicator())
)

export const TimeIcon = () => {
  return (
    <>
      <CprIcon name={'misc-timer'} />
      <span className={styles.navLabel}>{`Time`}</span>
      <div style={{ position: 'relative', left: '-12px', top: '-40px' }}>
        <Suspense fallback={<></>}>
          <TimeIndicator />
        </Suspense>
      </div>
    </>
  );
};
